import KendoChart from '../KendoChart'
import KendoChartSeriesItem from '../KendoChartSeriesItem'
import KendoStockChart from '../KendoStockChart'
import KendoSparkline from '../KendoSparkline'
import KendoSparklineSeriesItem from '../KendoSparkline/KendoSparklineSeriesItem'



let KendoChartInstaller = class {
    static install(Vue) {
        Vue.component(KendoChart.name, KendoChart)
        Vue.component(KendoChartSeriesItem.name, KendoChartSeriesItem)
        Vue.component(KendoStockChart.name, KendoStockChart)
        Vue.component(KendoSparkline.name, KendoSparkline)
        Vue.component(KendoSparklineSeriesItem.name, KendoSparklineSeriesItem)
    }
}

export default KendoChartInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoChartInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/kendo-chart-installer/index.js